// Curated Google Fonts (all with Hebrew support) offered in the inbox
// settings. Each entry pins the weight axis that font actually publishes —
// requesting a missing weight makes the css2 endpoint return 400 and the
// font silently never loads (e.g. Secular One only ships weight 400).
export const GOOGLE_FONTS = [
  { family: 'Heebo', weights: '400;500;600;700' },
  { family: 'Rubik', weights: '400;500;600;700' },
  { family: 'Assistant', weights: '400;500;600;700' },
  { family: 'Arimo', weights: '400;500;600;700' },
  { family: 'Open Sans', weights: '400;500;600;700' },
  { family: 'Noto Sans Hebrew', weights: '400;500;600;700' },
  { family: 'Frank Ruhl Libre', weights: '400;500;600;700' },
  { family: 'Alef', weights: '400;700' },
  { family: 'Miriam Libre', weights: '400;700' },
  { family: 'David Libre', weights: '400;500;700' },
  { family: 'Varela Round', weights: '' },
  { family: 'Secular One', weights: '' },
  { family: 'Suez One', weights: '' },
];

// Unknown families get no weight axis, so any valid Google Font name still
// loads (at its default weight) when set through the API.
export const buildGoogleFontHref = family => {
  const catalogEntry = GOOGLE_FONTS.find(font => font.family === family);
  const encoded = family.replace(/ /g, '+');
  const axis = catalogEntry?.weights ? `:wght@${catalogEntry.weights}` : '';
  return `https://fonts.googleapis.com/css2?family=${encoded}${axis}&display=swap`;
};
